import isPlainObject from 'lodash.isplainobject';
const getIdsFromArray = (relationImageData, relationProp, imageId) => {
  if (!relationImageData.length) return [imageId];
  return relationImageData.map(image => {
    if (!Object.keys(image).length) return '';
    return image[relationProp];
  }).filter(Boolean);
};
const getImageIds = (imageRelation, relationData, imageId) => {
  const imageIdArray = imageId ? [imageId] : [];
  if (relationData && relationData.entityData) {
    const [imageData] = imageRelation;
    const [relationName, relationProp] = imageData.split('.');
    const relationImageData = relationData.entityData[relationName];
    if (!relationImageData) return imageIdArray;
    if (Array.isArray(relationImageData)) return getIdsFromArray(relationImageData, relationProp, imageId);
    if (isPlainObject(relationImageData) && Object.keys(relationImageData).length) {
      return Array.isArray(relationImageData[relationProp]) ? relationImageData[relationProp] : [relationImageData[relationProp]];
    }
  }
  return imageIdArray;
};
export default getImageIds;
//# sourceMappingURL=get-image-ids.js.map